module.exports = __webpack_public_path__ + "img/icons.2c623e42.svg";